var map = {
	"./combine/logo.svg": "5cf0",
	"./default/logo.svg": "842e",
	"./fooyo/logo.svg": "edcc",
	"./tiny_toes/logo.svg": "107a",
	"./wholesale/logo.svg": "d407",
	"./zoo/logo.svg": "dca8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5c8d";